import { useState } from "react"
import { router } from "@inertiajs/react"
import { StepShell } from "../components/StepShell"
import { AuditForm } from "@/components/planning/AuditForm"

export function Audit({ data }) {
  const [scores, setScores] = useState(data.quarter.auditScores || {})
  const [answered, setAnswered] = useState(0)
  const [complete, setComplete] = useState(false)
  const [processing, setProcessing] = useState(false)

  const submit = () => {
    setProcessing(true)
    router.patch(
      "/app/plan/intake",
      { step: "audit", audit_scores: scores, advance: "1" },
      {
        preserveScroll: true,
        onFinish: () => setProcessing(false),
      },
    )
  }

  return (
    <StepShell
      title="Integrated Life Audit"
      subtitle={`Answer each 1 (needs attention) through 5 (thriving). ${answered}/${AuditForm.TOTAL_QUESTIONS} answered.`}
      onNext={submit}
      nextDisabled={!complete}
      processing={processing}
    >
      <AuditForm
        initialScores={data.quarter.auditScores || {}}
        onChange={({ scores: next, answered: a, complete: c }) => {
          setScores(next)
          setAnswered(a)
          setComplete(c)
        }}
      />
    </StepShell>
  )
}
